import { config } from '../config'
import * as _ from '../underscore'

export const retry = (action, retries) => {
  const retryCount =
    action.meta?.offline?.retryCount ?? config.api?.retryCount ?? 0

  return retries >= retryCount ? null : _.sec
}
